import React from "react";
import { styles } from "../../styles";
import type { OwnedNftOption } from "../hooks/useWalletNftDiscovery";

interface NftDiscoveryFieldsProps {
  connected: boolean;
  discoveringNfts: boolean;
  ownedNftOptions: OwnedNftOption[];
  nftDiscoveryError: string | null;
  selectedOwnedNftIdx: string;
  onDiscover: () => void;
  onSelectOwnedNftIdx: (value: string) => void;
}

export default function NftDiscoveryFields({
  connected,
  discoveringNfts,
  ownedNftOptions,
  nftDiscoveryError,
  selectedOwnedNftIdx,
  onDiscover,
  onSelectOwnedNftIdx,
}: NftDiscoveryFieldsProps) {
  return (
    <>
      <button
        type="button"
        onClick={onDiscover}
        disabled={!connected || discoveringNfts}
        style={{
          ...styles.button,
          width: "auto",
          padding: "7px 10px",
          fontSize: "12px",
          marginBottom: "8px",
        }}
      >
        {discoveringNfts ? "Discovering..." : "Discover Wallet NFTs"}
      </button>
      {ownedNftOptions.length > 0 && (
        <>
          <label
            style={{ ...styles.label, color: "#b0c4de", fontSize: "12px" }}
          >
            Owned NFT
          </label>
          <select
            style={{ ...styles.input, color: "#e8eeff" } as React.CSSProperties}
            value={selectedOwnedNftIdx}
            onChange={(e) => onSelectOwnedNftIdx(e.target.value)}
          >
            <option
              value=""
              style={{ background: "#1a1a2e", color: "#e8eeff" }}
            >
              Select discovered NFT
            </option>
            {ownedNftOptions.map((nft, idx) => (
              <option
                key={`${nft.contract}-${nft.tokenId}-${idx}`}
                value={String(idx)}
                style={{ background: "#1a1a2e", color: "#e8eeff" }}
              >
                {nft.name} ({nft.tokenType.toUpperCase()}) #{nft.tokenId}
              </option>
            ))}
          </select>
        </>
      )}
      {nftDiscoveryError && (
        <div
          style={{ fontSize: "12px", color: "#fca5a5", marginBottom: "8px" }}
        >
          {nftDiscoveryError}
        </div>
      )}
    </>
  );
}
